<template>
  <div>
    <sweet-modal blocking :title="isCreate ? 'Add Brands' : 'Edit Brands'" ref="modal" class="modal" v-on:close="closeModal('form')">
      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-form-item prop="code">
          <el-input label="Code" v-model.trim="form.code" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input label="Name" v-model="form.name" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <div class="btn__flex-end">
            <div v-if="isCreate">
              <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
              <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
            </div>
            <div v-else>
              <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
              <el-button @click="editItem('form')" type="primary">{{$t('general_submit')}}</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </sweet-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: 'create-update-modal',
    components: {
      SweetModal
    },
    data() {
      return {
        isCreate: true,
        row: null,

        mangerList: [],
        buList: [],
        projectList: [],
        form: {
          code: null,
          name: null,
        },

        rules: {
          code: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      async openModal({ isCreate = true, row = {} }) {
        this.isCreate = isCreate
        this.row = row
        // await this.directories()
        if (!isCreate) {
          await this.handleEdit()
        }
        this.$refs.modal.open()
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      closeModal(ref){
        this.$refs[ref].resetFields();
      },
      async directories() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`api/v1/inventories/directories?companyId=${this.$route.query.companyId}`)
          console.log("🚀 ~ file: CreateUpdateModal.vue:108 ~ directories ~ data:", data)
          this.mangerList = data.list.managers
          this.buList = data.list.buList
          this.$refs.modal.open()
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      addItem(form){
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            let loader = this.$loading.show();
            try {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.post(`/api/v1/items/brands?companyId=${this.$route.query.companyId}`, this.form)
              this.$refs.modal.close()
              this.$emit('loadList')
              loader.hide()
            } catch (error) {
              console.log('An error occurred:', error);
              loader.hide()
            }
          } else {
            console.log('Error valid!');
            return false;
          }
        });
      },
      async handleEdit() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items/brands?id=${this.row.id}`)
          for (const key in this.form) {
            this.form[key] = data.item[key]
          }
          this.$refs.modal.open()
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      editItem(form){
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            let loader = this.$loading.show();
            try {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.put(`/api/v1/items/brands?id=${this.row.id}`, this.form)
              this.$refs.modal.close()
              this.$emit('loadList')
              loader.hide()
            } catch (error) {
              console.log('An error occurred:', error);
              loader.hide()
            }
          }else {
            console.log('Error valid!');
            return false;
          }
        });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>